import Vue from 'vue';
import App from './App.vue';
import router from './router';
import NowUiKit from './plugins/now-ui-kit';
import datepicker from 'vuejs-datepicker';
Vue.use(datepicker);
import calendar from 'v-calendar';
Vue.use(calendar);
import 'vue-search-select/dist/VueSearchSelect.css';

import { ServerTable, ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bootstrap4');

import validator from 'validator';
Vue.use(validator);

Vue.config.productionTip = false;

Vue.use(NowUiKit);


import Amplify from "aws-amplify";
import awsconfig from "./aws-exports";

Amplify.configure(awsconfig);


import { Auth } from "aws-amplify";
import VueAxios from 'vue-axios';
import axios from 'axios';
const axiosApiInstance = axios.create()
axiosApiInstance.interceptors.request.use(
  async config => {
    if (localStorage.getItem("idToken")) {
      await Auth.currentAuthenticatedUser();
      Auth.currentSession()
        .then((data) => {
          localStorage.setItem("idToken", data["idToken"]["jwtToken"]);
        })
        .catch((err) => {
          // console.log(err);
        });
    }
    config.headers = { "Authorization": `Bearer ${localStorage.getItem("idToken")}` }
    return config;
  },
  async error => {
    Promise.reject(error)
  });
Vue.use(VueAxios, axiosApiInstance);

import Router from 'vue-router';

Vue.use(Router);


import "primevue/resources/themes/saga-blue/theme.css"       //theme
import "primevue/resources/primevue.min.css"                 //core css
import "primeicons/primeicons.css"                           //icons
import 'primeflex/primeflex.css';
import Tooltip from 'primevue/tooltip';

Vue.directive('tooltip', Tooltip);

import PrimeVue from 'primevue/config';
Vue.use(PrimeVue, {
  locale: {
    dateFormat: "dd-mm-yy",
    firstDayOfWeek: 1,
    dayNames: [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado",
    ],
    dayNamesShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
    dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
    monthNames: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
    monthNamesShort: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ],
    today: "Hoy",
    clear: "Borrar",
    weekHeader: "Sm",
  }
});

import ToastService from 'primevue/toastservice';
Vue.use(ToastService);
new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
